import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgExchange = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-exchange';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.241 6.03v2.79l2.499 2.34a195 195 0 0 0 2.533 2.351c.019.006.261-.229.538-.523l.504-.534-2.277-2.134L4.76 8.186V4.76l1.57.003 1.57.004.776.837.776.837.244-.229.547-.514.303-.285-1.015-1.087L8.515 3.24H3.24zm9.599-.29a195 195 0 0 0-2.351 2.533c-.006.019.229.261.523.538l.534.504 2.134-2.277 2.134-2.278h3.426l-.003 1.57-.004 1.57-.837.776-.837.776.229.244.514.547.285.303 1.087-1.015 1.086-1.016V3.24l-2.79.001h-2.79zm1.55 5.271-.46.575 2.655 2.132 2.655 2.133v3.389h-1.93l-1.93-.001-.94-.863-.94-.862-.1.118c-.055.065-.283.314-.506.554l-.406.436 1.166 1.069 1.165 1.069h5.941l-.002-2.81-.001-2.81-2.915-2.339a260 260 0 0 0-2.953-2.351c-.021-.007-.245.245-.499.561M4.31 14.483l-1.07 1.001v5.276l2.79-.001h2.79l2.34-2.499a195 195 0 0 0 2.351-2.533c.013-.04-1.002-1.007-1.056-1.007-.019 0-.988 1.017-2.152 2.26l-2.117 2.26H4.76l.003-1.57.004-1.57.837-.776.837-.776-.228-.244c-.518-.554-.783-.824-.807-.823-.014 0-.507.451-1.096 1.002"
    })
  }));
});
export default SvgExchange;